var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevisevisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "px",
    y: "0px",
    viewBox: "-910 500 100 80",
    style: {
      enableBackground: "new -909 491 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -874.8,
    y: 529.6,
    width: 11.7,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -874.8,
    y: 535,
    width: 20.8,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-830.7,549.3c-0.9-0.2-1.8,0.3-2,1.2c-2.2,8.5-7.5,15.7-15,20.1c-7.5,4.5-16.4,5.8-24.9,3.6   c-17.5-4.4-28.2-22.3-23.8-39.9c4.3-16.9,21.1-27.4,38-24.2l-1.2,4.8l12.9-3.6l-9.6-9.3l-1.2,4.9c-18.7-3.7-37.3,7.9-42,26.6   c-4.9,19.3,6.9,39.1,26.2,44c3,0.8,6,1.1,8.9,1.1c6.4,0,12.8-1.7,18.5-5.1c8.3-4.9,14.2-12.8,16.6-22.2   C-829.2,550.5-829.8,549.5-830.7,549.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-821.8,517.7c-2.1-2.4-5.7-2.6-8.1-0.6l-0.4,0.4l-0.6,0.5l-2.3,2l-0.3,0.2l-10.6,9.3h0l-0.6,0.5v-6.5   c0-0.9-0.8-1.7-1.7-1.7H-881c-0.9,0-1.7,0.8-1.7,1.7v41c0,0.9,0.8,1.7,1.7,1.7h34.6c0.9,0,1.7-0.8,1.7-1.7v-19.3l3.9-3.4l2.2-1.9   l3.2-2.8l2.2-1.9l1.1-1l6-5.2l2.5-2.1l1.1-1l0.2-0.2C-819.9,523.8-819.7,520.1-821.8,517.7z M-848,562.9h-31.2v-37.6h31.2v7.8   l-7,6.1l-2.8,2.4v-1.4h-17v2.5h15.7l0,0l-3.4,3h-12.3v2.5h10.8l-1.8,3.3l-0.2,0.3l-2.7,5.2c0,0,0,0,0,0l-0.2,0.3   c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.7,0.4,1.1,0.4c0,0,0.1,0,0.1,0l0.4-0.1l11.6-4.2c0.2-0.1,0.3-0.2,0.4-0.2l7.1-6.1V562.9z    M-860.6,548.7C-860.6,548.7-860.6,548.7-860.6,548.7c0.5,0.4,1.1,0.9,1.6,1.5c0.6,0.7,1,1.2,1.3,1.8c0,0,0,0,0,0   c0.1,0.3,0.3,0.6,0.4,0.8l-4.6,1.7l-1.8-2l2.3-4.3h0C-861.1,548.3-860.8,548.5-860.6,548.7z M-831.4,530.6l-3.6,3.1l-5.5,4.8   l-2.2,1.9l-2,1.8l-3.3,2.9l-7.3,6.4c-0.1-0.2-0.2-0.5-0.4-0.7c-0.4-0.7-0.9-1.4-1.6-2.2c-0.1-0.2-0.3-0.3-0.4-0.5   c-0.5-0.5-1-1-1.5-1.4c-0.2-0.2-0.4-0.3-0.6-0.4l0.5-0.5l0.2-0.2l7.1-6.2l3.9-3.4l0.4-0.3l1.4-1.2l1.6-1.4l4.1-3.6l0.8-0.7l0.5-0.5   l3.9-3.4c2.9,1.5,4.1,3.8,4.6,5L-831.4,530.6z M-830,529.4c-0.6-1.4-1.8-3.5-4.6-5l0.7-0.6c2.9,1.5,4.1,3.9,4.5,5.1L-830,529.4z    M-823.8,524.1l-1,0.8l-0.4,0.4l-0.2,0.2l-1.2,1l-0.5,0.4l-1.1,1l-0.4,0.3c-0.5-1.4-1.8-3.5-4.5-5.1l0.1-0.1l0.1-0.1l1.8-1.6l1.1-1   l1.1-1l0.3-0.2v0l0.2-0.2c1.4-1.2,3.6-1.1,4.8,0.3C-822.3,520.7-822.4,522.9-823.8,524.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisevisit);
export default __webpack_public_path__ + "static/media/revisevisit.83ef15fcfb2ce89594f3310d80ab06e4.svg";
export { ForwardRef as ReactComponent };